$(function(){
    $('#root').css('zoom','normal')
    let scale = document.body.clientWidth / 1080;
    $('#root').css('zoom',scale)

    window.addEventListener('resize',function(){
        var timer;
        return function(){
            if(timer) clearTimeout(timer);
            timer = setTimeout(function(){
            console.log("optimizedResize。。。。。")
            $('#root').css('zoom','normal')
            let scale = document.body.clientWidth / 1080;
            $('#root').css('zoom',scale)
            },100)
        }
    }())
})